
export default () => ({
    newsletterEmail: '',
    init() {
        console.log('result')
    },
    sendFormToKlaviyo(list, inputEmailId, formId, successID){

        let email = document.getElementById(inputEmailId).value;
        if(email == "" || document.getElementById(inputEmailId).checkValidity() == false){
            document.getElementById('newslwtterError').classList.remove('hidden')
            console.log('error')
            return
        }


        let settings = {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Cache-Control": "no-cache"
            },
            body: new URLSearchParams({
                g: list,
                email: email,
                $source: "Newsletter Form"
            })
        };

        fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", settings)
            .then(function(response) {
                return response.text();
            })
            .then(result => {
                console.log(result)
                document.getElementById(formId).classList.add('hidden')
                document.getElementById(successID).classList.remove('hidden')
            })
            .catch(function(error) {
                console.error("Error:", error);
            });


    }
})
